import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';
import {callTargetedAction, destroyStore, setUpStore} from 'client/framework';
import SimpleDropdown from 'generic/SimpleDropdown/SimpleDropdown.react';
import DateRange from 'client/generic/DateRange/DateRange.react';
import scopeSelectorActions from './ScopeSelector.actions';
import ScopeSelectorStore from './ScopeSelector.store';
import './scope-selector.scss';

const maxDateRange = 365;

// These identify the selector components available in this selector
export const selectorComponentNames = {
  attemptSelector: 'attemptSelector',
  dateRangeSelector: 'dateRangeSelector',
  subjectSelector: 'subjectSelector'
};

export default class ScopeSelector extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    // As `YYYY-MM-DD`
    defaultEndDate: PropTypes.string,
    defaultStartDate: PropTypes.string,
    // subject ID
    defaultSubjectId: PropTypes.string,
    destroyStoreOnUnmount: PropTypes.bool,
    // Set of string selector component names to include in this scope selector
    includedSelectors: ImmutablePropTypes.set.isRequired,
    // Map of selectorComponentNames name to the list of options you wish that selector to use
    selectorComponentOptions: ImmutablePropTypes.map.isRequired,
    selectorStoreName: PropTypes.string.isRequired
  };

  static defaultProps = {
    destroyStoreOnUnmount: false
  };

  constructor(props) {
    super(props);
    this.getStore();
    this.bootstrapSelectorStore();
  }

  componentWillUnmount() {
    if (this.props.destroyStoreOnUnmount) {
      destroyStore(this.props.selectorStoreName);
    }
  }

  getStore() {
    return setUpStore(ScopeSelectorStore, this.props.selectorStoreName);
  }

  bootstrapSelectorStore() {
    callTargetedAction({
      name: scopeSelectorActions.RECONFIGURE_SCOPE_SELECTOR,
      targetStore: this.props.selectorStoreName,
      payload: this.props.includedSelectors
    });
  }

  render() {
    const componentOptions = this.props.selectorComponentOptions;
    const content = [];
    const store = this.getStore();
    if (this.props.includedSelectors.has(selectorComponentNames.subjectSelector)) {
      const componentStoreName = store.getStoreNameForSelector(
        selectorComponentNames.subjectSelector
      );
      content.push(
        <SimpleDropdown
          fullWidth
          destroyStoreOnUnmount={this.props.destroyStoreOnUnmount}
          label='Subject'
          activeItemId={this.props.defaultSubjectId}
          storeName={componentStoreName}
          className='scope-selector-options__dropdown'
          options={componentOptions.get(selectorComponentNames.subjectSelector)}
          key='subject-scope'
        />
      );
    }

    if (this.props.includedSelectors.has(selectorComponentNames.attemptSelector)) {
      const componentStoreName = store.getStoreNameForSelector(
        selectorComponentNames.attemptSelector
      );
      content.push(
        <SimpleDropdown
          fullWidth
          destroyStoreOnUnmount={this.props.destroyStoreOnUnmount}
          label='Attempt Number'
          storeName={componentStoreName}
          className='scope-selector-options__dropdown'
          options={componentOptions.get(selectorComponentNames.attemptSelector)}
          key='attempt-scope'
        />
      );
    }

    if (this.props.includedSelectors.has(selectorComponentNames.dateRangeSelector)) {
      const componentStoreName = store.getStoreNameForSelector(
        selectorComponentNames.dateRangeSelector
      );
      content.push(
        <DateRange
          maxRange={maxDateRange}
          resetStoreOnUnmount={this.props.destroyStoreOnUnmount}
          storeName={componentStoreName}
          initialStartDate={this.props.defaultStartDate}
          initialEndDate={this.props.defaultEndDate}
          key='date-scope'
        />
      );
    }

    return (
      <div className={classnames('scope-selector-options', this.props.className)}>{content}</div>
    );
  }
}
